





















import Vue from 'vue'
import AddPermission from './AddPermission.vue'
import {MasterlinkMenuServiceProxy,MasterlinkApiScopeServiceProxy, MenuScopeApiItemDto} from '@/service-proxies/app-v2/system.service-proxies'

const menuServiceProxy = new MasterlinkMenuServiceProxy()
const apiScopeServiceProxy = new MasterlinkApiScopeServiceProxy()

const columns = [
  {
    title: '',
    dataIndex: 'operation',
    scopedSlots: {customRender: 'operation'},
    ellipsis: true
  },
  {
    title: '权限名称',
    dataIndex: 'scopeName',
    ellipsis: true
  },
  {
    title: '权限编号',
    dataIndex: 'resourceCode',
    scopedSlots: {customRender: 'icon'},
    ellipsis: true
  },
  {
    title: '接口方法',
    dataIndex: 'httpMethod',
    ellipsis: true
  },
  {
    title: '接口路径',
    dataIndex: 'scopePath',
    ellipsis: true
  },
];

export default Vue.extend({
  components: {
    AddPermission
  },
  props: {
    menuId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: [] as MenuScopeApiItemDto[],
      columns,
      addPerimissionVisible: false
    }
  },
  created() {
    this.getScopeList()
  },
  watch: {
    menuId () {
      this.getScopeList()
    }
  },
  methods: {
    getScopeList() { // 查询权限列表
      menuServiceProxy.getApisInMenu(this.menuId).then((res: any) => {
        // console.log('接口列表:', res)
        if (res) {
          this.data = res.data.itemDtoList
          this.data.map((item: any, i: any) => item.key = i)
          this.data = [...this.data]
        }
      })
    },
    addPermission() {
      this.addPerimissionVisible = true
    },
    close(reload?: boolean) {
      this.addPerimissionVisible = false
      if (reload) {
        this.getScopeList()
      }
    },
    deletePermission(record: any) {
      apiScopeServiceProxy.deleteMenuApi(record.id).then((res: any) => {
        if (res) {
          this.$message.success("删除成功！")
          this.getScopeList()
        }
      })
    }
  }
})
